import { render, staticRenderFns } from "./lockscreen-1.vue?vue&type=template&id=282b90dd&"
import script from "./lockscreen-1.vue?vue&type=script&lang=js&"
export * from "./lockscreen-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports